
import {
    modelServices
} from '@/app/shared/services/client-agent-service.js';
import {
    httpClient
} from '@/app/shared/services/http-client/http-client.js';


export class VisitService {

    constructor() {
        this.SearchVisitServiceDataByClassification = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetVisitServiceSearchResult").URL;
        this.GetProductByClassification = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetProductByClassification").URL;
        this.GetPhysicianOdataUrl = modelServices.baseUrl + modelServices.getPharmacyServiceName("PhysicianOData").URL;
        this.ViewReceiptItemsOdataUrl = modelServices.baseUrl + modelServices.getPharmacyServiceName("ViewReceiptItemsOData").URL;

    }

    InitPharmaciestVisitViewByCassification(visitServiceSearchParams, callback, errCallback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InitPharmaciestVisitViewByCassification").URL;

        return httpClient.post(url, visitServiceSearchParams).then(callback).catch(errCallback);

    }
    InitPharmacistPrescriptionVisitView(initParams, callback, errCallback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InitPharmacistPrescriptionVisitView").URL;
        return httpClient.post(url, initParams).then(callback).catch(errCallback);
    }
    SearchOutpatientVisitServiceData(visitServiceSearchParams, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetVisitServices").URL;

        return httpClient.post(url, visitServiceSearchParams).then(callback);

    }

    InitDiscountPopup(callback, errCallback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InitDiscountPopup").URL;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback).catch(errCallback);

    }



    GetEmployeeByCategory(jobCategoryId, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetEmployeeByCategory").URL + "?jobCategoryId=" + jobCategoryId;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }


    EditServicesDiscount(discountServiceList, callback, errCallback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("EditServicesDiscount").URL;

        return httpClient.post(url, discountServiceList).then(callback).catch(errCallback);

    }

    GetServiceFooterSummeryByClassification(QueryStringUrl, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetServiceSummeryFooter").URL + QueryStringUrl;

        return httpClient.get(url).then(callback);
    }

    GetPaymentTransactions(visitID) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("PaymentTransactions").URL + "?visitID=" + visitID;
        return url;
    }


    GetBillingLKP(clinicInstanceStartDate, clinicInstanceStartTime, visitId, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetBillingLKP").URL + "?clinicInstanceStartDate=" + clinicInstanceStartDate + "&clinicInstanceStartTime=" + clinicInstanceStartTime + "&visitId=" + visitId;
        var options = {
            method: 'GET',
            url: url,
        };
        httpClient(options).then(callback);
    }

    GetBillingContract(clinicInstanceStartDate, clinicInstanceStartTime, contractorId, contractorClientId, beneficiaryTypeId, contractCategoryId, contractId, visitId, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetBillingContract").URL + "?clinicInstanceStartDate=" + clinicInstanceStartDate + "&clinicInstanceStartTime=" + clinicInstanceStartTime +
            "&contractorId=" + contractorId + "&contractorClientId=" + contractorClientId + "&beneficiaryTypeId=" + beneficiaryTypeId + "&contractCategoryId=" + contractCategoryId + "&contractId=" + contractId + "&visitId=" + visitId;
        var options = {
            method: 'GET',
            url: url,
        };
        httpClient(options).then(callback);
    }

    GetBillingContractorClient(clinicInstanceStartDate, clinicInstanceStartTime, contractorId, visitId, IsEdit, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetBillingContractorClient").URL + "?clinicInstanceStartDate=" + clinicInstanceStartDate + "&clinicInstanceStartTime=" + clinicInstanceStartTime + "&contractorId=" + contractorId + "&visitId=" + visitId + "&IsEdit=" + IsEdit;
        var options = {
            method: 'GET',
            url: url,
        };
        httpClient(options).then(callback);
    }



    ChangeFinancialStateToCash(CashModel, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("ChangeFinancialStateToCash").URL;
        return httpClient.post(url, CashModel).then(callback);

    }

    EditVisitFinancialStatus(visitFinincailInfoModelObj, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("EditVisitFinancialStatus").URL;

        return httpClient.post(url, visitFinincailInfoModelObj).then(callback);

    }


    getInsuranceCardList(PatientInfo, callback) {


        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetInsuranceCardList").URL + "?patientID=" + PatientInfo.patientID +
            "&isAllowExpiredInsuranceCard=" + PatientInfo.IsExpired + "&VisitId=" + PatientInfo.VisitID + "&purchasingDate=" + PatientInfo.clinicInstanceStartDateTime + "&isCreatedByPharmacyWalkIn=" + PatientInfo.isCreatedByPharmacyWalkIn;

        var options = {
            method: 'GET',
            url: url
        };
        httpClient(options).then(callback);

    }


    deleteInsuranceCard(InsuranceCardID, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("deleteInsuranceCard").URL + "?InsuranceCardID=" + InsuranceCardID;
        var options = {
            method: 'delete',
            url: url,
        };
        httpClient(options).then(callback);
    }

    ValidateInsuredBillingData(clinicInstanceStartDate, clinicInstanceStartTime, contractorId, contractorClientId, beneficiaryTypeId, contractCategoryId, selectedContract, visitId, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("ValidateInsuredBillingData").URL + "?clinicInstanceStartDate=" + clinicInstanceStartDate + "&clinicInstanceStartTime=" + clinicInstanceStartTime
            + "&contractorId=" + contractorId + "&contractorClientId=" + contractorClientId + "&beneficiaryTypeId=" + beneficiaryTypeId + "&contractCategoryId=" + contractCategoryId + "&selectedContract=" + selectedContract + "&visitId=" + visitId;
        var options = {
            method: 'GET',
            url: url,
        };
        httpClient(options).then(callback);
    }

    InitPharmacyReceptionistAddService(addItemParams, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InitPharmacyReceptionistAddService").URL + "?classificationId=" + addItemParams.classificationId + "&servedById=" + addItemParams.servedById + "&isAddItem=" + addItemParams.isAddItem;
        var options = {
            method: 'GET',
            url: url,
        };
        httpClient(options).then(callback);
    }

    GetProductDetails(productDetailsParams, callback) {
        var productQueryString = "";
        var productIds = [];

        if (productDetailsParams.productID.length > 0) {

            for (let i = 0; i < productDetailsParams.productID.length; i++) {
                productIds += "&productsIDs[" + i + "]=" + productDetailsParams.productID[i];
            }

            productQueryString = productIds.slice(1);
        }
        else {
            productQueryString = "productsIDs=" + productDetailsParams.productID;
        }

        var parameters = "?" + productQueryString;

        if (productDetailsParams.servedById) {
            parameters += "&servedById=" + productDetailsParams.servedById;
        }
        if (productDetailsParams.isAddItem) {
            parameters += "&isAddItem=" + productDetailsParams.isAddItem;
        }
        if (productDetailsParams.getWarehousesForAll) {
            parameters += "&getWarehousesForAll=" + productDetailsParams.getWarehousesForAll;
        }

        if (productDetailsParams.VisitID) {
            parameters += "&VisitID=" + productDetailsParams.VisitID;
        }

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetPharmacyProductDetails").URL + parameters;
        var options = {
            method: 'GET',
            url: url,
        };
        httpClient(options).then(callback);
    }

    GetAvailableBatches(params, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetAvailablePharmacyBatches").URL + "?productID=" + params.productID + "&unitOfMeasuerID=" + params.unitOfMeasuerID + "&warehouseID=" + params.warehouseID + "&WarehouseLocationID=" + params.WarehouseLocationID;
        var options = {
            method: 'GET',
            url: url,
        };

        httpClient(options).then(callback);
    }

    RePrice(VisitID, callback, errCallback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("RePrice").URL + "?VisitID=" + VisitID;
        var options = {
            method: 'GET',
            url: url,
        };
        httpClient(options).then(callback).catch(errCallback);
    }

    GetSourceOfBusinessData(callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetSourceOfBusinessData").URL;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }

    GetAllVisitSource(callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetAllVisitSource").URL;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }

    UpdateSourceOfBusiness(visitId, sobId, patientId, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("UpdateSourceOfBusiness").URL + "?visitId=" + visitId + "&sobId=" + sobId + "&patientId=" + patientId;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }


    RetrieveMedicationOL(OLRequestModel) {        
        let OrderlineStatus = [];
        if (OLRequestModel.OrderlineStatus.length > 0) {
            for (var i = 0; i < OLRequestModel.OrderlineStatus.length; i++) {
                OrderlineStatus += "&OrderlineStatus[" + i + "]=" + OLRequestModel.OrderlineStatus[i];
            }
        }

        let CreatedbyModule = [];
        if (OLRequestModel.CreatedbyModule.length > 0) {
            for (i = 0; i < OLRequestModel.CreatedbyModule.length; i++) {
                CreatedbyModule += "&CreatedbyModule[" + i + "]=" + OLRequestModel.CreatedbyModule[i];
            }
        }
        else {
            CreatedbyModule = "&CreatedbyModule=" + OLRequestModel.CreatedbyModule;
        }

        let CreationNeedID = [];
        if (OLRequestModel.CreationNeedID && OLRequestModel.CreationNeedID.length > 0) {
            for (i = 0; i < OLRequestModel.CreationNeedID.length; i++) {
                CreationNeedID += "&CreationNeedID[" + i + "]=" + OLRequestModel.CreationNeedID[i];
            }
        }


        let filter = '';
        let authStatus = [];
        let billingStatus = [];
        if (OLRequestModel.AuthApprovalStatus) {
            authStatus = [...OLRequestModel.AuthApprovalStatus];
        }
        if (OLRequestModel.BillingApprovalStatus) {
            billingStatus = [...OLRequestModel.BillingApprovalStatus];
        }
        if (authStatus.length) {
            filter = `&$filter=(AuthApprovalStatusID eq ${authStatus.join(' or AuthApprovalStatusID eq ')})`;
        }
        if (billingStatus.length) {
            if (filter == '') {
                filter = `&$filter=BillingApprovalstatusID eq ${billingStatus.join(' or BillingApprovalstatusID eq ')}`
            } else {
                filter = `${filter} and (BillingApprovalstatusID eq ${billingStatus.join(' or BillingApprovalstatusID eq ')})`
            }
        }

        return modelServices.baseUrl + modelServices.getPharmacyServiceName("RetrieveMedicationOL").URL
            + "?VisitID=" + OLRequestModel.VisitID + "&ProductID=" + OLRequestModel.ProductID
            + "&DispensedTodate=" + OLRequestModel.DispensedTodate + "&Orderlinefromdate="
            + OLRequestModel.Orderlinefromdate + "&OrderlineTodate=" + OLRequestModel.OrderlineTodate
            + "&PhysicianID=" + OLRequestModel.PhysicianID + OrderlineStatus
            + "&IsHomeMedication=" + OLRequestModel.IsHomeMedication            
            + CreatedbyModule + CreationNeedID + filter;

    }

    RetrieveMedicationOLProducts(OLRequestModel) {
        return modelServices.baseUrl + modelServices.getPharmacyServiceName("RetrieveMedicationOLProducts").URL + "?VisitID=" + OLRequestModel.VisitID;
    }

    GetPatientFinancialInfoForPharmacy(patientId, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetPatientFinancialInfoForPharmacy").URL + "?patientId=" + patientId;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }


    GetAllPhysicians(callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetAllPhysicians").URL;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }

    GetOrderLineStatusData(callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetOrderLineStatusData").URL;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }


    GetServiceNoteByServiceID(visitServiceId,OwnMedicationTransactionID, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetServiceNoteByServiceID").URL;
        
        url = url + "?visitServiceId=" + (visitServiceId ? visitServiceId : null);
                
        url += "&OwnMedicationTransactionID=" + (OwnMedicationTransactionID ? OwnMedicationTransactionID : null)
        
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }



    AddServiceNote(addServiceNoteObject, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("AddServiceNote").URL;

        return httpClient.post(url, addServiceNoteObject).then(callback);

    }

    DeletePrivateServiceNote(deleteServiceNote, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("DeletePrivateServiceNote").URL;

        return httpClient.post(url, deleteServiceNote).then(callback);

    }

    GetPatientOrderlinesReceptionNotes(orderlineID, productClassificationID, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetPatientOrderlinesReceptionNotes").URL;
        var OrderlineIDList = "?OrderlineIDList[0].OrderlineID=" + parseInt(orderlineID) + "&OrderlineIDList[0].ProductClassificationID=" + parseInt(productClassificationID);

        var options = {
            method: 'GET',
            url: url + OrderlineIDList,

        };
        httpClient(options).then(callback);

    }

    AddVisitNote(AddVisitNoteData, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("AddVisitNote").URL;

        return httpClient.post(url, AddVisitNoteData).then(callback);

    }

    GetBatchPricing(initParams, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetBatchPricing").URL;
        return httpClient.post(url, initParams).then(callback);
    }

    InitCancelVisitPopup(callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InitCancelVisitPopup").URL;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }

    CancelVisit(initParams, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("CancelVisit").URL;
        return httpClient.post(url, initParams).then(callback);
    }


    CancelPharmacyVisitService(CancelServiceParameters, callback) {
        var param = "?serviceId=" + CancelServiceParameters.ServiceID + "&modifiedTS=" + CancelServiceParameters.ModifiedTS;

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("CancelPharmacyVisitService").URL + param;
        return httpClient.delete(url).then(callback);
    }



    InitRevertDischargeVisitPopup(callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InitRevertDischargeVisitPopup").URL;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }


    ConfirmRevertDischargedVisit(initParams, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("ConfirmRevertDischargedVisit").URL;
        return httpClient.post(url, initParams).then(callback);
    }

    DischargeVisit(visitID, modifiedTS, isZeroPricedConfirmed, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("DischargeVisit").URL;
        var options = {
            method: 'PUT',
            url: url,
            params: {
                "visitID": visitID,
                "modifiedTS": modifiedTS,
                "isZeroPricedConfirmed": isZeroPricedConfirmed
            }
        };
        httpClient(options).then(callback);
    }

    GetConvertedQuantityToSalesUOM(model, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetConvertedQuantityToSalesUOM").URL;

        return httpClient.post(url, model).then(callback);

    }

    GetWarehouseLocations(model, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetWarehouseLocation").URL;

        return httpClient.post(url, model).then(callback);

    }

    GetAssignedWarehousesLocationsOfUser(model, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetAssignedWarehousesLocationsOfUser").URL;

        return httpClient.post(url, model).then(callback);
    }

    GetProductsAvailableQty(model, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetAvailableQty").URL;

        return httpClient.post(url, model).then(callback);

    }

    GetUserDisplayNames(userIDs, callback) {
        let param = '';
        if (userIDs.length > 0) {
            for (var i = 0; i < userIDs.length; i++) {
                param += "&userIDs[" + i + "]=" + userIDs[i];
            }
        }
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetUserDisplayNames").URL + "?" + param;
        var options = {
            method: 'GET',
            url: url,
        };
        return httpClient(options).then(callback);
    }



    GetAlternatives(tradeNameID, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetAlternatives").URL + "?tradeNameID=" + tradeNameID;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }

    ChargeAndDispensItem(visitServiceModel, callback, errCallback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("ChargeAndDispensItem").URL;
        return httpClient.post(url, visitServiceModel).then(callback).catch(errCallback);
    }
    ChargeItem(visitServiceModel, callback, errCallback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("ChargeItem").URL;
        return httpClient.post(url, visitServiceModel).then(callback).catch(errCallback);
    }
    DispenseItemsToNurse(itemsModel, callback, errCallback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("updateMedicationorderlinequantities").URL;
        return httpClient.post(url, itemsModel).then(callback).catch(errCallback);
    }

    CreateVisitByPharmacist(visitServiceModel, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("CreateVisitByPharmacist").URL;
        return httpClient.post(url, visitServiceModel).then(callback);
    }
    ConfirmPharamcyReturnNew(returnItemsModal, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("ConfirmPharamcyReturnNew").URL;
        return httpClient.post(url, returnItemsModal).then(callback);
    }

    ReturnByReceipt(returnItemsModal, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("ReturnByReceipt").URL;
        return httpClient.post(url, returnItemsModal).then(callback);
    }

    AddClientToSpecificContractor(contractorclientObj, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("AddClientToSpecificContractor").URL;
        return httpClient.post(url, JSON.stringify(contractorclientObj)).then(callback);
    }

    InitServiceDose(ServiceTransactionIds, OwnMedicationTransationIds, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InitServiceDose").URL;
        var options = {
            method: 'GET',
            url: url,
            params: { 'ServiceTransactionIds': ServiceTransactionIds, 'OwnMedicationTransationIds': OwnMedicationTransationIds }
        };
        httpClient(options).then(callback);
    }

    SaveAndPrintServiceDose(visitId, patientAgeEn, patientAgeAr, visitServicesDose, callback) {
        let url = modelServices.baseUrl + modelServices.getPharmacyServiceName("SaveAndPrintServiceDose").URL;
        let serviceDoseInputs = {
            "VisitId": visitId,
            "PatientAgeEn": patientAgeEn,
            "PatientAgeAr": patientAgeAr,
            "VisitServicesDose": visitServicesDose
        }
        return httpClient.post(url, serviceDoseInputs).then(callback);

    }

    GetContractorClientNameForView(contractorClientObject) {
        return contractorClientObject.PolicyNumber != "" && contractorClientObject.PolicyNumber != null ? contractorClientObject.PolicyNumber + " || " + contractorClientObject.Name : contractorClientObject.Name;
    }

    MarkPharmcyServicesAsNeedsApproval(ServicesAsNeedsApprovalModel, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("MarkPharmcyServicesAsNeedsApproval").URL;
        return httpClient.post(url, ServicesAsNeedsApprovalModel).then(callback);
    }
    UndoMarkPharmcyServicesAsNeedsApproval(ServicesAsNeedsApprovalModel, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("UndoMarkPharmcyServicesAsNeedsApproval").URL;
        return httpClient.post(url, ServicesAsNeedsApprovalModel).then(callback);
    }

    BulkInAssignCoverLetter(ServiceApprovalLetterModel, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("PharmacyBulkInAssignCoverLetter").URL;

        return httpClient.post(url, ServiceApprovalLetterModel).then(callback);

    }

    EditPharmacyVisitService(EditClaimDateParams, callback, errCallback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("EditPharmacyVisitService").URL;

        return httpClient.post(url, EditClaimDateParams).then(callback).catch(errCallback);
    }

    InitOpenAttachmentPopup(params, callback, errCallback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InitOpenAttachmentPopup").URL + "?VisitID=" + params.VisitID + "&PatientID=" + params.PatientID + "&moduleID=" + params.moduleID + "&orderLineID=" + params.orderLineID + "&isVisitAttachement=" + params.isVisitAttachement;
        var options = {
            method: 'GET',
            url: url
        };
        return httpClient(options).then(callback).catch(errCallback);
    }

    AssignPatientAttachmentToVisit(patientAttachmentID, visitID, moduleID, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("AssignPatientAttachmentToVisit").URL;
        var options = {
            method: 'POST',
            url: url,
            params: {
                patientAttachmentID: patientAttachmentID,
                visitID: visitID,
                moduleID: moduleID
            },
        };
        return httpClient(options).then(callback);
    }

    PharmacyDeleteAttachments(patientAttachmentID, modifiedTS, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("PharmacyDeleteAttachments").URL;
        var options = {
            method: 'POST',
            url: url,
            params: {
                visitAttachmentId: patientAttachmentID,
                modifiedTS: modifiedTS
            },
        };
        return httpClient(options).then(callback);
    }


    Savefiles(AttachmentsObj, Addfile, callback, errCallback) {
        var formData = new FormData();
        var model = { ...AttachmentsObj };
        model.files = undefined;
        formData.append("model", JSON.stringify(model));
        formData.append("file", Addfile);

        var options = {
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            url: modelServices.baseUrl + modelServices.getPharmacyServiceName("Savefiles").URL,
            data: formData,
        };
        httpClient(options).then(callback).catch(errCallback);
    }



    InAssignPatientAttachmentToVisit(patientAttachmentID, visitID, callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InAssignPatientAttachmentToVisit").URL;
        var options = {
            method: 'POST',
            url: url,
            params: {
                patientAttachmentID: patientAttachmentID,
                visitID: visitID
            },
        };
        return httpClient(options).then(callback);
    }

    PharmacyDownloadAttachment(visitAttachmentId,callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("PharmacyDownloadAttachment").URL;

        var options = {
            method: 'GET',
            url: url,
            params: { 'visitAttachmentId': visitAttachmentId },
            responseType: 'arraybuffer'
        };

        return httpClient(options).then(callback);

    }

    PharmacyDownloadAttachmentForPrint(visitAttachmentId,callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("PharmacyDownloadAttachmentForPrint").URL;

        var options = {
            method: 'GET',
            url: url,
            params: { 'visitAttachmentId': visitAttachmentId },
            responseType: 'arraybuffer'
        };

        return httpClient(options).then(callback);

    }

    InitReturnByReceiptGrid(receiptID, callback) {
        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InitReturnByReceiptGrid").URL;
        var options = {
            method: 'GET',
            url: url,
            params: { receiptID: receiptID },
        };
        return httpClient(options).then(callback);
    }

    GetOrderEntryStaticLookup(callback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetOrderEntryStaticLookup").URL;
        var options = {
            method: 'GET',
            url: url,

        };
        httpClient(options).then(callback);

    }

    GetMainSolutionsAndPhysicians(model,callback) {
        let url = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetMainSolutionsAndPhysicians").URL
        url = `${url}?`;
        if (model.VisitID) {
            url = `${url}&VisitID=${model.VisitID}`;
        }
        if (model.PatientID) {
            url = `${url}&PatientID=${model.PatientID}`;
        }
        if (model.IsFluid) {
            url = `${url}&IsFluid=${model.IsFluid}`;
        }
        if (model.DateFrom) {
            url = `${url}&DateFrom=${model.DateFrom}`;
        }
        if (model.DateTo) {
            url = `${url}&DateTo=${model.DateTo}`;
        }

        httpClient.get(url).then(callback);
    }

}

const visitService = new VisitService();

export { visitService };